import axios from "axios";

const REF_KEY = "hg_ref";
export const saveRef = (code) => { if (/^[A-Za-z0-9]{4,12}$/.test(code || "")) { localStorage.setItem(REF_KEY, code.toUpperCase()); } };
const getRef = () => localStorage.getItem(REF_KEY) || undefined;
const clearRef = () => localStorage.removeItem(REF_KEY);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export const auth = {
  me: () => http.get("/auth/me").then(r => r.data),
  login: (email, password) => http.post("/auth/login", { email, password }).then(r => r.data),
  register: (data) => http.post("/auth/register", { ...data, ref: getRef() }).then(r => { clearRef(); return r.data; }),
  logout: () => http.post("/auth/logout").then(r => r.data),
  googleSession: (session_id) => http.post("/auth/google/session", { session_id, ref: getRef() }).then(r => { clearRef(); return r.data; }),
};

export const loads = {
  list: (params) => http.get("/loads", { params }).then(r => r.data),
  get: (id) => http.get(`/loads/${id}`).then(r => r.data),
  create: (data) => http.post("/loads", data).then(r => r.data),
  patch: (id, data) => http.patch(`/loads/${id}`, data).then(r => r.data),
  del: (id) => http.delete(`/loads/${id}`).then(r => r.data),
};
export const vehicles = {
  list: (params) => http.get("/vehicles", { params }).then(r => r.data),
  get: (id) => http.get(`/vehicles/${id}`).then(r => r.data),
  create: (data) => http.post("/vehicles", data).then(r => r.data),
  patch: (id, data) => http.patch(`/vehicles/${id}`, data).then(r => r.data),
  del: (id) => http.delete(`/vehicles/${id}`).then(r => r.data),
  pdfUrl: (id) => `${API}/vehicles/${id}/pdf`,
  pdfBlob: (id) => http.get(`/vehicles/${id}/pdf`, { responseType: "blob", timeout: 120000 }).then(r => r.data),
};
export const vinDecode = (vin) => http.get(`/vin/decode/${vin}`).then(r => r.data);
export const inspections = {
  create: (data) => http.post("/inspections", data).then(r => r.data),
};
export const locations = {
  list: () => http.get("/locations").then(r => r.data),
  create: (data) => http.post("/locations", data).then(r => r.data),
  lookup: (address) => http.get("/locations/lookup", { params: { address } }).then(r => r.data),
  patch: (id, data) => http.patch(`/locations/${id}`, data).then(r => r.data),
  del: (id) => http.delete(`/locations/${id}`).then(r => r.data),
};
export const files = {
  upload: (file, kind="photo") => {
    const fd = new FormData();
    fd.append("file", file); fd.append("kind", kind);
    return http.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
  },
  url: (id) => `${API}/files/${id}`,
};
export const summary = () => http.get("/dashboard/summary").then(r => r.data);

export const billing = {
  plans: () => http.get("/billing/plans").then(r => r.data),
  me: (refresh = false) => http.get("/billing/me", { params: refresh ? { refresh_now: true } : {} }).then(r => r.data),
  checkout: (lookup_key) => http.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }).then(r => r.data),
  status: (sid) => http.get(`/payments/status/${sid}`).then(r => r.data),
  portal: () => http.post("/billing/portal", { origin_url: window.location.origin }).then(r => r.data),
};

export const fleet = {
  get: () => http.get("/fleet").then(r => r.data),
  rename: (name) => http.patch("/fleet", { name }).then(r => r.data),
  invite: (email) => http.post("/fleet/invites", { origin_url: window.location.origin, email }).then(r => r.data),
  revoke: (token) => http.delete(`/fleet/invites/${token}`).then(r => r.data),
  info: (token) => http.get(`/fleet/invites/${token}/info`).then(r => r.data),
  join: (token) => http.post("/fleet/join", { token }).then(r => r.data),
  remove: (id) => http.delete(`/fleet/members/${id}`).then(r => r.data),
  leave: () => http.post("/fleet/leave").then(r => r.data),
};

export const referrals = {
  me: () => http.get("/referrals/me").then(r => r.data),
};

export const finance = {
  expenses: (loadId) => http.get(`/loads/${loadId}/expenses`).then(r => r.data),
  addExpense: (loadId, data) => http.post(`/loads/${loadId}/expenses`, data).then(r => r.data),
  delExpense: (id) => http.delete(`/expenses/${id}`).then(r => r.data),
  setMiles: (loadId, loaded_miles) => http.patch(`/loads/${loadId}/miles`, { loaded_miles }).then(r => r.data),
  setRate: (vid, rate) => http.patch(`/vehicles/${vid}/rate`, { rate }).then(r => r.data),
  month: () => http.get("/finance/month").then(r => r.data),
  report: (month) => http.get("/finance/report", { params: { month } }).then(r => r.data),
  exportCsv: (month) => http.get("/finance/export", { params: { month }, responseType: "blob" }).then(r => r.data),
};

export const activity = {
  feed: (params) => http.get("/activity", { params }).then(r => r.data),
  drivers: () => http.get("/activity/drivers").then(r => r.data),
};

// After sign-in, return to a pending fleet invite if there is one
export const postAuthPath = () => {
  const t = sessionStorage.getItem("hg-join");
  return t ? `/join/${t}` : "/app";
};

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
};
